// Client-side task edit-permission helpers — mirror the server's PATCH /crm/tasks gate
// (assignee / creator / admin) so the UI hides controls that would 403. The JWT is decoded
// each call (cheap); roles are trimmed+lowercased exactly like the server's isAdminReq.

function decodeToken() {
  try {
    const seg = (localStorage.getItem('mickey_token') || '').split('.')[1];
    if (!seg) return null;
    // JWT payloads are base64url — normalize to base64 (+ padding) before atob.
    const b64 = seg.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch { return null; }
}

export function myEmail() {
  return decodeToken()?.email || null;
}

export function myRoles() {
  const p = decodeToken();
  if (!p) return [];
  return Array.isArray(p.roles) ? p.roles : (p.role ? [p.role] : []);
}

export function amAdmin() {
  return myRoles().some((r) => String(r).trim().toLowerCase() === 'admin');
}

// True when the current user may edit this task: an admin, the assignee (owner_email),
// or the creator (created_by). Matches server loadTaskForEdit().
export function canEditTask(task) {
  if (!task) return false;
  if (amAdmin()) return true;
  const me = myEmail();
  if (!me) return false;
  const lower = me.toLowerCase();
  return [task.owner_email, task.created_by].some((e) => e && String(e).toLowerCase() === lower);
}
